<template>
    <div class="feature">
        <div class="text-ma-blue-1 fill-current inline-flex" v-html="feature.icon"></div>

        <h3 class="text-lg mb-1 text-black">
            {{ feature.title }}
        </h3>
        <p class="text-ma-gray-3 text-sm">
            {{ feature.text }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        feature: {
            type: Object,
            required: true
        }
    }
}
</script>